import { on } from 'delegated-events'

const els = document.querySelectorAll('.element-media')

const loadYouTubeApi = () => {
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'

  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

const loadVimeoApi = () => {
  const tag = document.createElement('script')
  tag.src = 'https://player.vimeo.com/api/player.js'
  tag.id = 'vimeo-api-js'

  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

const players = {}

export default {
  can: () => els.length,
  run: () => {
    if (document.querySelectorAll('.element-media .media-youtube').length) {
      loadYouTubeApi()

      window.onYouTubeIframeAPIReady = () => {
        document.querySelectorAll('.element-media .media-youtube').forEach((el) => {
          const mediaId = el.dataset.mediaId

          const player = new YT.Player(el, {
            height: '100%',
            width: '100%',
            videoId: el.dataset.videoId,
            playerVars: {
              playsinline: 1,
            },
          })

          players[mediaId] = player
        })

        on('click', '.media-youtube + button', (e) => {
          const button = e.target.closest('button')
          const mediaId = button.dataset.mediaId

          button.classList.add('hidden')

          players[mediaId].playVideo()
        })
      }
    }

    if (document.querySelectorAll('.element-media .media-vimeo').length) {
      loadVimeoApi()

      document.getElementById('vimeo-api-js').addEventListener('load', () => {
        document.querySelectorAll('.element-media .media-vimeo').forEach((el) => {
          const mediaId = el.dataset.mediaId
          const videoId = el.dataset.videoId
          const videoUrl = el.dataset.videoUrl

          const opts = {}

          if (videoId) {
            opts.id = videoId
          }

          if (videoUrl) {
            opts.url = videoUrl
          }

          const player = new Vimeo.Player(el, opts)

          players[mediaId] = player
        })
      })

      on('click', '.media-vimeo + button', (e) => {
        const button = e.target.closest('button')
        const mediaId = button.dataset.mediaId

        button.classList.add('hidden')

        players[mediaId].play()
      })
    }
  },
}
